//Settings
import { MEGA_API, Sistema_ID, SERIAL_PADRAO } from "./constants";

//Libs
import axios from "axios";
import mockedRequest from "../mocking/mocked-request";

axios.defaults.headers.post["content-type"] = "application/json;charset=utf-8";

let doRequestWrapper;

doRequestWrapper = ({
  url = "",
  method = "GET",
  headers,
  data,
  params,
} = {}) => {
  if (data.chrSerial == undefined) {
    data.chrSerial = SERIAL_PADRAO;
  }

  data.Sistema_ID = data.Sistema_ID || Sistema_ID;

  return axios({ url, method, headers, data, params, baseURL: MEGA_API })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

if (process.env.NODE_ENV === "test") {
  doRequestWrapper = mockedRequest;
}

export const doRequest = doRequestWrapper;



// WEBPACK FOOTER //
// ./src/modules/request.js